import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.pad-start.js";
import { downloadWord } from '~/functions/export';
import { FundStrategy, ReportType, useExportFundReportLazyQuery, useExportPaiReportLazyQuery, useExportPrecontractualReportLazyQuery, useGetFundQuery, useListReferencePeriodsQuery } from '~/types/types';
import { getLocale } from '~/functions/translate';
export default defineComponent({
  props: {
    fundId: {
      type: Number,
      required: true
    },
    fundName: {
      type: String,
      required: true
    },
    reportType: {
      type: String,
      // add ReportType Enum
      required: true
    },
    referencePeriodId: {
      type: Number,
      required: false,
      default: 72 // id for 2024
    }
  },
  setup: function setup(props, context) {
    var locale = getLocale();
    var selectedLanguage = ref(locale.value);
    var _useGetFundQuery = useGetFundQuery({
        id: props.fundId
      }),
      result = _useGetFundQuery.result;
    var fund = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getFund;
    });
    var _useListReferencePeri = useListReferencePeriodsQuery({
        filters: {
          ids: [props.referencePeriodId]
        }
      }),
      refPeriodResult = _useListReferencePeri.result;
    var referencePeriod = computed(function () {
      var _refPeriodResult$valu, _refPeriodResult$valu2;
      return refPeriodResult !== null && refPeriodResult !== void 0 && (_refPeriodResult$valu = refPeriodResult.value) !== null && _refPeriodResult$valu !== void 0 && _refPeriodResult$valu.listReferencePeriods ? refPeriodResult === null || refPeriodResult === void 0 ? void 0 : (_refPeriodResult$valu2 = refPeriodResult.value) === null || _refPeriodResult$valu2 === void 0 ? void 0 : _refPeriodResult$valu2.listReferencePeriods[0] : null;
    });
    var languageItems = computed(function () {
      var _fund$value, _fund$value2, _fund$value3;
      if (props.reportType === ReportType.SfdrPai) {
        return [{
          text: locale === 'en' ? 'English' : 'Englisch',
          value: 'en-US'
        }, {
          text: locale === 'en' ? 'German' : 'Deutsch',
          value: 'de-DE'
        }];
      }
      if (props.reportType === ReportType.SfdrPeriodic && ((_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.fundStrategy) === FundStrategy.Article_8) {
        return [{
          text: locale === 'en' ? 'English' : 'Englisch',
          value: 'en-US'
        }, {
          text: locale === 'en' ? 'German' : 'Deutsch',
          value: 'de-DE'
        }];
      }
      if (props.reportType === ReportType.SfdrPrecontractual && ((_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : _fund$value2.fundStrategy) === FundStrategy.Article_8 || ((_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : _fund$value3.fundStrategy) === FundStrategy.Article_8Plus) {
        return [{
          text: locale === 'en' ? 'English' : 'Englisch',
          value: 'en-US'
        }, {
          text: locale === 'en' ? 'German' : 'Deutsch',
          value: 'de-DE'
        }];
      }
      return [{
        text: 'English',
        value: 'en-US'
      }];
    });
    var input = computed(function () {
      if (props.reportType === ReportType.SfdrPeriodic || props.reportType === ReportType.SfdrPai) {
        return {
          fundId: props.fundId,
          locale: selectedLanguage.value,
          referencePeriodId: props.referencePeriodId
        };
      } else {
        return {
          fundId: props.fundId,
          locale: selectedLanguage.value
        };
      }
    });
    var reportTypeString = computed(function () {
      if (props.reportType === ReportType.SfdrPeriodic) {
        return 'Periodic';
      } else if (props.reportType === ReportType.SfdrPai) {
        return 'PAI';
      } else if (props.reportType === ReportType.SfdrPrecontractual) {
        return 'Precontractual';
      }
    });
    var reportPrefix = computed(function () {
      if (props.reportType === ReportType.SfdrPeriodic) {
        return 'Periodic';
      } else if (props.reportType === ReportType.SfdrPai) {
        return 'PAI Consideration';
      } else if (props.reportType === ReportType.SfdrPrecontractual) {
        return 'Precontractual';
      }
    });
    var resolverName = computed(function () {
      if (props.reportType === ReportType.SfdrPeriodic) {
        return 'exportFundReport';
      } else if (props.reportType === ReportType.SfdrPai) {
        return 'exportPaiReport';
      }
      return 'exportPrecontractualReport';
    });

    // TODO: Refactor this to use a single query function. Move logic to the resolver.
    var queryFunctions = computed(function () {
      switch (props.reportType) {
        case ReportType.SfdrPeriodic:
          return useExportFundReportLazyQuery({
            input: input.value
          }, {
            fetchPolicy: 'network-only'
          });
        case ReportType.SfdrPai:
          return useExportPaiReportLazyQuery({
            input: input.value
          }, {
            fetchPolicy: 'network-only'
          });
        default:
          return useExportPrecontractualReportLazyQuery({
            input: input.value
          }, {
            fetchPolicy: 'network-only'
          });
      }
    });
    var _queryFunctions$value = queryFunctions.value,
      load = _queryFunctions$value.load,
      onResult = _queryFunctions$value.onResult,
      refetch = _queryFunctions$value.refetch,
      loading = _queryFunctions$value.loading;
    var toggleDialogRef = ref(function () {});
    function getFormattedDate() {
      var currentDate = new Date();
      return "".concat(currentDate.getFullYear(), "_").concat(String(currentDate.getMonth() + 1).padStart(2, '0'), "_").concat(String(currentDate.getDate()).padStart(2, '0'));
    }
    function handleDownload(res) {
      var _res$data;
      var file = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data[resolverName.value].file;
      if (file) {
        var _referencePeriod$valu;
        downloadWord(file, "".concat(props.fundName, " ").concat(reportPrefix.value, " Report ").concat(referencePeriod === null || referencePeriod === void 0 ? void 0 : (_referencePeriod$valu = referencePeriod.value) === null || _referencePeriod$valu === void 0 ? void 0 : _referencePeriod$valu.label, ".docx"));
        context.emit('finish');
        toggleDialogRef.value(); // Calls the toggleDialog function that is passed as a prop into triggerExport.
        toggleDialogRef.value = function () {}; // Resets the toggleDialogRef to an empty function.
      }
    }
    onMounted(function () {
      onResult(function (res) {
        if (!loading.value) {
          handleDownload(res);
        }
      });
    });
    function triggerExport(toggleDialog) {
      load(null, {
        input: input.value
      }) || refetch();
      toggleDialogRef.value = toggleDialog;
    }
    return {
      triggerExport: triggerExport,
      loading: loading,
      selectedLanguage: selectedLanguage,
      languageItems: languageItems,
      reportTypeString: reportTypeString
    };
  }
});